import apiClient from '@/services/axios';

export async function get(query) { //  = "*"
  var response = await apiClient.get(`/ActivationPlanEvents/?query=${query}`)
  if (response) {
    return response.data
  }

  throw new Error('Unable to get calendar events')
}